import React from "react";
import { CalendarDays, ExternalLink, Loader2 } from "lucide-react";
import RdvRow from "../molecules/RdvRow";
import BureauCard from "../atoms/BureauCard";
import { INK, INK_3, BURGUNDY, LINE } from "../bureauTokens";

function RdvRowSkeleton() {
  return (
    <div className="flex items-center gap-2.5" style={{ padding: "8px" }}>
      <div className="h-2.5 w-12 rounded animate-pulse flex-shrink-0" style={{ background: LINE }} />
      <div className="flex-1 min-w-0 space-y-1.5">
        <div className="h-2.5 w-24 rounded animate-pulse" style={{ background: LINE }} />
        <div className="h-2.5 w-32 rounded animate-pulse" style={{ background: LINE }} />
      </div>
    </div>
  );
}

// `loading` (squelette plein, isLoading global) : rien n'est encore prêt.
// `syncingGoogle` : les RDV internes sont déjà affichés (dispo plus vite,
// via fetchAll), Google Agenda synchronise encore en arrière-plan — juste
// une note discrète en bas de liste, pas de squelette bloquant (voir
// EtatGlobal.js#fetchGoogleCalendarOverview, volontairement hors isLoading).
function RdvCard({ title, rdvs, onSeeAll, onOpenItem, loading, syncingGoogle }) {
  return (
    <BureauCard>
      <div className="flex items-center justify-between mb-1">
        <div className="flex items-center gap-2 text-xs font-semibold" style={{ color: INK }}>
          <CalendarDays size={14} style={{ color: BURGUNDY }} /> {title}
        </div>
        <button
          onClick={onSeeAll}
          className="flex items-center gap-1 text-[11px] font-medium hover:opacity-80 transition-opacity"
          style={{ color: INK_3 }}
        >
          <ExternalLink size={11} /> Planning
        </button>
      </div>
      <div className="mt-1 flex flex-col gap-0.5">
        {loading ? (
          Array.from({ length: 3 }).map((_, i) => <RdvRowSkeleton key={i} />)
        ) : (
          <>
            {rdvs.map((rdv) => (
              <RdvRow key={rdv.id} rdv={rdv} onClick={() => onOpenItem(rdv)} />
            ))}
            {rdvs.length === 0 && !syncingGoogle && (
              <div className="py-6 text-center text-xs" style={{ color: INK_3 }}>
                Aucun RDV à venir
              </div>
            )}
            {syncingGoogle && (
              <div className="flex items-center justify-center gap-1.5 py-2.5 text-[11px]" style={{ color: INK_3 }}>
                <Loader2 size={11} className="animate-spin" />
                Synchronisation Google Agenda en cours…
              </div>
            )}
          </>
        )}
      </div>
    </BureauCard>
  );
}

export default RdvCard;
